module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vertical-tabs"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-718ef32e"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/form/VerticalTab.vue
// module id = 173
// module chunks = 1